import { submissionContent } from "./content";
import { SectionCard } from "./SectionCard";
import { FieldRow } from "./FieldRow";
import { Textarea } from "./primitives";
import { Input } from "../ui/input";

const mandatoryMessage = "Your answer is required.";

export function ProductInfoSection({ invalidFields = [] }: { invalidFields?: string[] }) {
  const c = submissionContent.productInfo;
  const isInvalid = (name: string) => invalidFields.includes(name);

  return (
    <SectionCard title={c.title}>
      <FieldRow label={c.fields.model} required error={isInvalid("product_model") ? mandatoryMessage : undefined}>
        <Input name="product_model" required data-invalid={isInvalid("product_model") ? "true" : "false"} />
      </FieldRow>

      <FieldRow
        label={c.fields.overview.label}
        hint={c.fields.overview.hint}
        required
        error={isInvalid("product_overview") ? mandatoryMessage : undefined}
      >
        <Textarea name="product_overview" required data-invalid={isInvalid("product_overview") ? "true" : "false"} />
      </FieldRow>

      <FieldRow
        label={c.fields.specs.label}
        hint={c.fields.specs.hint}
        required
        error={isInvalid("product_specs") ? mandatoryMessage : undefined}
      >
        <Textarea name="product_specs" required data-invalid={isInvalid("product_specs") ? "true" : "false"} />
      </FieldRow>

      <FieldRow
        label={c.fields.features.label}
        hint={c.fields.features.hint}
        required
        error={isInvalid("product_features") ? mandatoryMessage : undefined}
      >
        <Textarea name="product_features" required data-invalid={isInvalid("product_features") ? "true" : "false"} />
      </FieldRow>

      <FieldRow
        label={c.fields.materials.label}
        hint={c.fields.materials.hint}
        required
        error={isInvalid("materials") ? mandatoryMessage : undefined}
      >
        <Textarea name="materials" required data-invalid={isInvalid("materials") ? "true" : "false"} />
      </FieldRow>

      <FieldRow
        label={c.fields.packaging.label}
        hint={c.fields.packaging.hint}
        required
        error={isInvalid("packaging_content") ? mandatoryMessage : undefined}
      >
        <Textarea
          name="packaging_content"
          required
          data-invalid={isInvalid("packaging_content") ? "true" : "false"}
        />
      </FieldRow>

      <FieldRow label={c.fields.markets} required error={isInvalid("major_markets") ? mandatoryMessage : undefined}>
        <Textarea name="major_markets" required data-invalid={isInvalid("major_markets") ? "true" : "false"} />
      </FieldRow>

      <FieldRow label={c.fields.brands} required error={isInvalid("brands_buying") ? mandatoryMessage : undefined}>
        <Textarea name="brands_buying" required data-invalid={isInvalid("brands_buying") ? "true" : "false"} />
      </FieldRow>
    </SectionCard>
  );
}
